var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffProductLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_2783",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 53
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 52.0001V1.00006H1V52.0001H52Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5757 3.83099C44.5757 2.28685 43.324 1.03524 41.78 1.03524H4.29012C2.74608 1.03524 1.49426 2.28685 1.49426 3.83099V8.23517H44.5757V3.83099Z",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3813 41.7126H39.4742L38.6041 34.6122C38.5701 34.3392 38.8649 34.1453 39.1031 34.2845L44.5756 37.4903V8.23553H1.49438V38.917C1.49438 40.4612 2.74579 41.7126 4.29003 41.7126H19.3129",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6039 34.6125L40.2056 47.6803C40.2416 47.9729 40.612 48.0782 40.7964 47.848L42.6405 45.5452C42.782 45.3686 43.0547 45.3813 43.179 45.5704L47.2828 51.8147C47.3838 51.9684 47.5904 52.0112 47.7442 51.9101L49.5498 50.7234L51.3553 49.5368C51.509 49.4357 51.5518 49.2292 51.4507 49.0754L47.3469 42.8312C47.2227 42.6421 47.319 42.3867 47.5373 42.3269L50.3828 41.5476C50.6671 41.4698 50.7175 41.0879 50.4631 40.9388L39.103 34.2844C38.865 34.145 38.5704 34.3387 38.6039 34.6125Z",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5276 21.5184H9.5813V14.5992H16.5276V21.5184Z",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.954 14.5994H36.5073",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.954 21.1384H36.5073",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58142 27.6775H36.5074",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58142 34.2166H31.9475",
    stroke: "#78A22F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffProductLogo);
export default __webpack_public_path__ + "static/media/offProductLogo.71ab74af7846f01e9a256256e26d98fa.svg";
export { ForwardRef as ReactComponent };